import Plotly from 'react-plotly.js'
export type ResponseContext = {
   followup_questions: string[] | null;
 
};
export type AskResponse = {
    answer: string;
    followup_q: ResponseContext;
    citations: Citation[];
    plotly_data: AzureSqlServerCodeExecResult | null
    error?: string;
    message_id?: string;
    feedbackOnMsg?: FeedbackEnum;
    msgStatus: messageStatus;
    date:string;
    exec_results?: ExecResults[];
    isCopilotResponse: string;
};
export type AzureSqlServerCodeExecResult = {
    data: Plotly.Data[]
    layout: Partial<Plotly.Layout>
}
export type ExecResults = {
    intent: string
    search_query: string | null
    search_result: string | null
    code_generated: string | null
}
export type AzureSqlServerExecResult = {
    intent: string
    search_query: string | null
    search_result: string | null
    code_generated: string | null
    code_exec_result?: AzureSqlServerCodeExecResult | undefined
}

export type AzureSqlServerExecResults = {
    all_exec_results: AzureSqlServerExecResult[]
}
export type HideCitations = {
    hideCitations: string;
}

export type ShowMsgFb = {
    showMsgFb: string;
}

export type SpeechAuth = {
    access_token: string;
    region: string;
};

export type Branding = {
    brand_name: string;
    brand_description: string;
    brand_welcome_message_count: number
    brand_welcome_message_line1: string;
    brand_welcome_message_line2: string;
    brand_welcome_message_line3: string;
    brand_welcome_message_line4: string;
    brand_welcome_message_line5: string;
    header_right_image: string;
    header_right_small_image: string;
    header_right_small_image_darkmode: string;
    header_left_image_darkmode: string;
    header_right_image_darkmode: string;
    header_left_image: string;
    header_left_link: string;
    header_title: string;
    show_heater_title_beta: string;
    show_copyright: string;
    copyright_text: string;
    show_privacy_policy: string;
    privacy_policy_text: string;
    show_user_terms: string;
    user_terms_text: string;
    show_site_translate: string;
    show_signin: string;
    dialog_logo:string;
    dialog_logo_darkmode: string;
    msg_icon:string;
    msg_icon_darkmode:string;
    microphone_text:string;
    caution_text:string;
    add_context:string;
    context:string;
    faqList:faq[];
    subsectionsList:subsection[];
    placeholder_long_text:string;
    placeholder_abbrev_text:string;
    speech_enabled: string;
    text_to_speech_enabled: string;
    text_to_speech_playbackrate: string;
    show_widget:string;
    widget_url:string;
    pgmList:string[];
    speech_error_msg:string;
    speech_waiting_msg:string;
    speech_enable_confidence_score:string;
    speech_default_language_list:string;
    speech_non_default_language_list: string;
    followup_questions_enabled:string;
    msg_feedback_enabled:string;
    citation_disabled:string;
    hide_citations_kb_button:string;
    feedback_message_positive:string;
    feedback_message_negative:string;
    feedback_message_neutral:string;
    feedback_info_text:string;
    pii_redaction_enabled: string;  
    telephony_api: string;
    telephony_var1: string;
    telephony_var2: string;
    sign_in_modal_copyright_show: string;
    sign_in_modal_message_show: string;
    sign_in_modal_message: string;
    subsection_collapse_default: string;
    profile_subsection_collapse_default: string;
    hide_faq_subsections: string;
    faq_panel_default_open: string;
    signout_close_time: string;
    signout_message: string;
    signout_title: string;
    copilot_flowdisplay_inwidget: string;
    copilot_flowdisplay_api: string;
    copilot_trigger_phrases: trigger_list[];
    password_visibility_icon_enabled: string;
    azure_b2c_client_id: string;
    azure_b2c_redirect_uri: string;
    azure_b2c_userflow_endpoint: string;
    azure_b2c_profileflow_endpoint: string;
    profile_pane_default_open: string;
    multiple_case_message: string;
    footer_terms_label: string;
    footer_privacy_label: string;
    footer_aicautions_label: string;
    slideup_terms_title: string;
    slideup_privacy_title: string;
    slideup_aicautions_title: string;
    show_top_of_page_button: string;
    show_skip_nav_panel: string;
    show_skip_nav_highlight: string;
    question_inputfield_character_limit: string;
    question_inputField_character_limit_tracker_enabled: string;
    show_submit_request_button: string;
    show_profile_panel: string;
    main_api: string;
    languages: string;
    citation_inputfield_character_limit: string;
    agent_name: string;
    show_knowledgebase_download: string;
    show_release_notes: string;
    show_pbi: string;
    release_notes_modal_message: string;
    release_date: string;
    show_release_notes_days_after: string;
    release_notes_url: string;
    YW_USE_AZURE_B2C?: string;
    b2c_tenant_subdomain?: string;
    b2c_tenant_id?: string;
    azure_b2c_password_reset_endpoint?: string;
    YW_Admin_App_URL?: string;
    is_admin?: boolean;
}

export type trigger_list = {
    flow_name: string;
    flow_trigger: string[];
}
export type FrontendSettings = {
    auth_enabled?: string | null;
    branding?: Branding;
    is_pending_access?: boolean;
    is_wrong_url?: boolean;
    matched_program_name?: string | null;
    filtered_internal_programs?: ProgramInternalInfo[];
    has_internal_programs?: boolean;
    can_view_all_programs?: boolean;
}

// B2C Internal Program Authentication Types
export type ProgramInternalInfo = {
    id?: string;
    config_code: string;
    program_name: string;
    program_group: string;
    program_roles?: string[];
};

export type AssignUserToProgramResponse = {
    success: boolean;
    message: string;
    program_name?: string;
    program_group?: string;
};

export type pgm = {
    //id:string;
    name:string;
}
export type faq = {
    question: string;
    answer: string;
    requiresAuth: string;
    authType: string;
    authFields: string;
    subSectionId: string;
}

export type subsection = {
    id: string;
    isActive: string;
    programCode: string;
    subSection: string;
    subSectionOrder: string;
}
export type Citation = {
    part_index?: number;
    content: string;
    id: string;
    title: string | null;
    filepath: string | null;
    url: string | null;
    metadata: string | null;
    chunk_id: string| null;
    reindex_id: string | null;
}

export type ToolMessageContent = {
    citations: Citation[];
    intent: string;
}

export type ChatMessage = {
    id: string;
    role: string;
    content: string;
    context: ResponseContext;
    end_turn?: boolean;
    date: string;
    prompt_tokens: number;
    completion_tokens: number;
    feedbackOnMsg?: FeedbackEnum;
    copilot_convId?: string;
    copilot_watermark?: string;
    isFaq?:string; 
    copilot_endConv?: string;
    clearAuth?: string;
    copilot_tranferAgent?: string;
    isStopped?: boolean;
    copilot_tranfertoFlow?: string;
};

export type FeedbackMessage = {
    rating: number;
    feedback:string;
    assistantMessageId?: string
    feedbackMsg?: string,
};


export type Conversation = {
    id: string;
    title: string;
    messages: ChatMessage[];
    date: string;
  
}

export enum ChatCompletionType {
    ChatCompletion = "chat.completion",
    ChatCompletionChunk = "chat.completion.chunk"
}

export type ChatResponseChoice = {
    messages: ChatMessage[];
}

export type ChatResponse = {
    id: string;
    model: string;
    created: number;
    object: ChatCompletionType;
    choices: ChatResponseChoice[];
    history_metadata: {
        conversation_id: string;
        title: string;
        date: string;
    }
    error?: any;
    isFaq?:string;
    isFaqUserMessage?:string;
}

export type ConversationRequest = {
    messages: ChatMessage[];
    chatUUID: string
};
export type FeedbackRequest = {
    message: FeedbackMessage[];
    chatUUID: string
};
export type UserInfo = {
    access_token: string;
    expires_on: string;
    id_token: string;
    provider_name: string;
    user_claims: any[];
    user_id: string;
};
export enum CosmosDBStatus {
    NotConfigured = "CosmosDB is not configured",
    NotWorking = "CosmosDB is not working",
    Working = "CosmosDB is configured and working",
}

export type CosmosDBHealth = {
    cosmosDB: boolean,
    status: string,
    allowMessageDelete: string
}

export enum ChatHistoryLoadingState {
    Loading = "loading",
    Success = "success",
    Fail = "fail",
    NotStarted = "notStarted"
}

export type ErrorMessage = {
    title: string,
    subtitle: string
}

export enum FeedbackEnum {
    Neutral = "neutral",
    Positive = "positive",
    Negative = "negative",
    MissingCitation = "missing_citation",
    WrongCitation = "wrong_citation",
    OutOfScope = "out_of_scope",
    InaccurateOrIrrelevant = "inaccurate_or_irrelevant",
    OtherUnhelpful = "other_unhelpful",
    HateSpeech = "hate_speech",
    Violent = "violent",
    Sexual = "sexual",
    Manipulative = "manipulative",
    OtherHarmful = "other_harmful"
}

export enum messageStatus {
    NotRunning = "Not Running",
    Processing = "Processing",
    Done = "Done"
}

export type ChatAppResponse = {
    choices: ResponseChoice[];
};
export type ResponseChoice = {
    index: number;
    message: string;
    has_toolmsg:string;
};

export type ExpandedSections = {
    [key: string]: boolean;
}

export type BlobList = {
    item: BlobListItem[];
}
export type BlobListItem = {
    name: string;
    lastmodified: string;
    size: string;
    url: string;
    type: string;
    adgroups:string;
}